import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const StakeColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
`;

export const LimitsHint = styled.div`
	color: ${BTTO_PROFILE_COLORS.textDim};
	font-size: 11px;
	font-weight: 400;
	line-height: 1.4;
	text-align: left;
	width: 100%;
	padding-left: 2px;

	[class*="MinMaxInfo"],
	[data-testid="step-deposit-amount-limits"],
	[data-testid="step-withdraw-amount-limits"] {
		display: block !important;
		width: 100% !important;
		margin: 0 !important;
		text-align: left !important;
		justify-content: flex-start !important;
	}
`;
